import bus from '@/utils/eventBus'

const alert = (name = 'event-alert', callback, title = 'Atenção', label = 'OK', message = '', cancel = 'Cancelar', type = 'sa-warning', closeOnClickMask = true) => {
  bus.$emit(name, {
    callback,
    show: true,
    title,
    message,
    label,
    cancel,
    closeOnClickMask
  })
}

export const warning = (message, title = 'Atenção!', label = 'OK', cancel = 'Cancelar', type = 'sa-warning', closeOnClickMask = true) => {
  return alert('event-alert', () => {}, title, label, message, cancel, type, closeOnClickMask)
}

export const error = (message, title = 'Erro!', label = 'OK', cancel = 'Cancelar', type = 'sa-error', closeOnClickMask = true) => {
  return alert('event-error', () => {}, title, label, message, cancel, type, closeOnClickMask)
}

export const confirmation = (callback, message = 'Deseja cancelar esse registro?', title = 'Confirmar Cancelamento', label = 'Remover', cancel = 'Cancelar', type = 'sa-warning', closeOnClickMask = false) => {
  return alert('event-confirm', callback, title, label, message, cancel, type, closeOnClickMask)
}

export const success = (message, title = 'Perfeito', label = 'OK', cancel = 'Cancelar', type = 'sa-success', closeOnClickMask = false) => {
  return alert('event-success', () => {}, title, label, message, cancel, type, closeOnClickMask)
}

export const included = (message, title = 'Perfeito', label = 'OK', cancel = 'Cancelar', type = 'sa-success', closeOnClickMask = false) => {
  return alert('event-included', () => {}, title, label, message, cancel, type, closeOnClickMask)
}



// WEBPACK FOOTER //
// ./src/utils/alert.js